import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { ListItem } from '../../types/listItem';
import { PublicApplicationService } from '../../api/v4/services';
import { VehicleAppService } from './vehicle-app.service';
import { PersonalAppService } from './personal-app.service';
import { ErrorService } from '../error.service';
import { LookupInternalResponse } from '../../api/v4/models/Models/v4/Common/lookup-internal-response';
import { AutocompleteAddress } from '../../api/v4/models/Models/Customer/autocomplete-address';
import { ModelsCustomerNzbnCompany, ModelsCustomerNzbnCompanyDetails, ModelsCustomerNzbnCompanyDetailsBaseResponse, ModelsCustomerNzbnCompanyResponse, ModelsCustomerNzbnCompanyResponseBaseResponse } from '../../api/v4/models';

@Injectable({
  providedIn: 'root',
  deps: [PublicApplicationService, VehicleAppService, PersonalAppService, ErrorService]
})
export class LookupService
{

  constructor(
    @Inject(PublicApplicationService) private publicApplicationService: PublicApplicationService,
    private vehicleAppService: VehicleAppService,
    private personalAppService: PersonalAppService,
    private errorService: ErrorService,
    private router: Router,

  ) { }

  private getApplicationId(): string | null {
    const applicationId = this.router.url.startsWith('/personal')
      ? this.personalAppService.newApplicationResponse.publicId
      : this.vehicleAppService.newApplicationResponse.publicId;

    if (applicationId && applicationId.trim() !== '') {
      return applicationId;
    }

    return null;
  }

  getCountries(): Observable<ListItem[]>
  {
    const applicationId = this.getApplicationId();
    if (!applicationId) {
      return of([]);
    }

    return this.publicApplicationService.v4PublicApplicationLookupsApplicationIdCountriesGet$Json({
      applicationId: applicationId
    }).pipe(
      map(response =>
      {
        // Assuming response.entityData is an array of objects with properties that can be mapped to ListItem
        return response?.entityData?.map((item: LookupInternalResponse) => ({
          value: item.memberCaption,
          displayName: item.displayName,
          valueCaption: item.memberCaption
        })) as unknown as ListItem[];
      })
    );
  }

  getAddressAutocomplete(addressSearch: string): Observable<AutocompleteAddress[]>
  {
    const applicationId = this.getApplicationId();
    if (!applicationId) {
      return of([]);
    }

    return this.publicApplicationService.v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json({
      query: addressSearch,
      applicationId: applicationId
    }).pipe(
      map(response =>
      {
        // console.log(response);
        return response?.entityData?.addresses ?? [];
      })
    );
  }

  getCompanyAutocomplete(companySearch: string): Observable<ModelsCustomerNzbnCompany[]>
  {
    const applicationId = this.getApplicationId();
    if (!applicationId) {
      return of([]);
    }

    return this.publicApplicationService.v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Json({
      query: companySearch,
      applicationId: applicationId
    }).pipe(
      map(response =>
      {
        console.log('getCompanyAutocomplete', response);
        return response?.entityData?.companies ?? [];
      })
    );
  }

  getCompanyDetails(nzbn: string): Observable<ModelsCustomerNzbnCompanyDetails | null>
  {
    const applicationId = this.getApplicationId();
    if (!applicationId) {
      return of(null);
    }

    return this.publicApplicationService.v4PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json({
      nzbn: nzbn,
      applicationId: applicationId
    }).pipe(
      map(response =>
      {
        console.log('getCompanyDetails', response);
        return response?.entityData ?? null;
      })
    );
  }
}
